import Axios, { Method } from "axios";

const callApi = async <T>(link: ResourceLink, resource?: Partial<T>) => {

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PATCH, POST, PUT, DELETE",
    "Authorization": (link.token??"")
  }
  
  //console.log((link as ResourceLink).href);
  const baseURL: string = process.env.NODE_ENV === "production" ? `${window.location.protocol}//${window.location.hostname}/` : "https://conecta.des.sp.gov.br"

  return await Axios({
    baseURL,
    timeout: 50000,
    headers: headers,
    method: link.type as Method,
    url: link.href,
    data: resource,
  });
};
export default callApi;
